export default "__VITE_PUBLIC_ASSET__75cf9c99__"